import React from 'react';
import PropTypes from 'prop-types';
import { interpolate } from '@format/interpolate';
import { ResponsiveImage } from '@web/molecules';
import { Heading, PillText } from '@web/atoms';
import { useShopifyOfferContext } from '../../offer/shopifyContext';
import {
  CardContainer,
  ImageWrapper,
  ContentWrapper,
  NumberCircle,
  TitleWrapper,
  BodyWrapper,
  BadgeContainer,
} from './styles';

export const SimpleCalloutCard = ({
  image,
  heading,
  body,
  badge,
  headingLevel = 'h3',
  icon,
  align,
  backgroundColor = 'background.base',
  contentAlignment = 'flex-start',
}) => {
  const { formattedAmount } = useShopifyOfferContext();
  return (
    <CardContainer $align={align}>
      {badge && (
        <BadgeContainer>
          <PillText
            text={interpolate(badge, { offer: formattedAmount ?? '50%' })}
            variant="kale"
          ></PillText>
        </BadgeContainer>
      )}

      <ImageWrapper>
        <ResponsiveImage {...image} />
      </ImageWrapper>
      <ContentWrapper $contentAlignment={contentAlignment}>
        <TitleWrapper>
          {icon && (
            <NumberCircle>
              <ResponsiveImage {...icon} />
            </NumberCircle>
          )}
          <Heading
            headingLevel={headingLevel}
            typography="heading6"
            headingText={interpolate(heading, {
              offer: formattedAmount ?? '50%',
            })}
            position="center"
            backgroundColor={backgroundColor}
          />
        </TitleWrapper>
        {body && (
          <BodyWrapper>
            {interpolate(body, { offer: formattedAmount })}
          </BodyWrapper>
        )}
      </ContentWrapper>
    </CardContainer>
  );
};

SimpleCalloutCard.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
  heading: PropTypes.string.isRequired,
  body: PropTypes.string,
  headingLevel: PropTypes.string,
  icon: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
  }),
  align: PropTypes.string,
  backgroundColor: PropTypes.string,
};
